import * as React from "react";
import JobsPanelContent from "./JobsPanelContent";
import { FlyoutLink } from "@app/shared/Flyouts";

interface JobsPanelContentLinkProps {
    containerId: string;
    projectId: number;
    projectName: string;
    triggerElementOverride?: React.RefObject<HTMLButtonElement>;
}

class JobsPanelContentLink extends React.Component<JobsPanelContentLinkProps> {

    public render() {
        return (
            <FlyoutLink
                classNames="col-12 action-menu-item side-panel-link font-weight-normal"
                content={{
                    body: this.renderEditContent(),
                    title: `Jobs - ${this.props.projectName}`,
                }}
                size="60"
                testId="jobs-panel-content-link__flyout"
                triggerElementOverride={this.props.triggerElementOverride}
            >
                <i className="fa fa-binoculars pr-1" /> Jobs
            </FlyoutLink>
        )
    }

    private renderEditContent() {
        return (
            <JobsPanelContent
                projectId={this.props.projectId}
                projectName={this.props.projectName}
            />
        );
    }
}

export default JobsPanelContentLink;
